export enum OrderLayout {
    Cards = 1,
    Table = 2
}